"use strict";
// (C) 2019-2020 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.treemapDimensions = exports.heatmapDimensions = exports.roundChartDimensions = exports.pointyChartDimensions = exports.stackedChartDimensions = exports.defaultDimensions = void 0;
var tslib_1 = require("tslib");
var sdk_model_1 = require("@gooddata/sdk-model");
var sdk_ui_1 = require("@gooddata/sdk-ui");
function isStackedChart(buckets, stackBucketName) {
    var stackBucket = sdk_model_1.bucketsFind(buckets, stackBucketName);
    return stackBucket && !sdk_model_1.bucketIsEmpty(stackBucket);
}
function stackedDimensions(buckets, viewBucketName, stackBucketName) {
    var viewBucket = sdk_model_1.bucketsFind(buckets, viewBucketName);
    var stackBucket = sdk_model_1.bucketsFind(buckets, stackBucketName);
    var viewByAttributes = viewBucket ? sdk_model_1.bucketAttributes(viewBucket) : [];
    var stackByAttribute = stackBucket && sdk_model_1.bucketAttribute(stackBucket);
    var stackByAttributeLocalIdentifier = stackByAttribute
        ? stackByAttribute.attribute.localIdentifier
        : undefined;
    var viewByAttributeLocalIdentifiers = viewByAttributes && viewByAttributes.map(sdk_model_1.attributeLocalId);
    return sdk_model_1.newTwoDimensional(stackByAttributeLocalIdentifier ? [stackByAttributeLocalIdentifier] : [], viewByAttributeLocalIdentifiers
        ? tslib_1.__spreadArrays(viewByAttributeLocalIdentifiers, [sdk_model_1.MeasureGroupIdentifier]) : [sdk_model_1.MeasureGroupIdentifier]);
}
function defaultDimensions(def) {
    return sdk_model_1.newTwoDimensional([sdk_model_1.MeasureGroupIdentifier], sdk_model_1.bucketsAttributes(def.buckets).map(sdk_model_1.attributeLocalId));
}
exports.defaultDimensions = defaultDimensions;
function stackedChartDimensions(def, viewBucketName, stackBucketName) {
    if (viewBucketName === void 0) { viewBucketName = sdk_ui_1.BucketNames.VIEW; }
    if (stackBucketName === void 0) { stackBucketName = sdk_ui_1.BucketNames.STACK; }
    var buckets = def.buckets;
    return isStackedChart(buckets, stackBucketName)
        ? stackedDimensions(buckets, viewBucketName, stackBucketName)
        : defaultDimensions(def);
}
exports.stackedChartDimensions = stackedChartDimensions;
function pointyChartDimensions(def) {
    return sdk_model_1.newTwoDimensional(sdk_model_1.bucketsAttributes(def.buckets).map(sdk_model_1.attributeLocalId), [sdk_model_1.MeasureGroupIdentifier]);
}
exports.pointyChartDimensions = pointyChartDimensions;
function roundChartDimensions(def) {
    var attributes = sdk_model_1.bucketsAttributes(def.buckets).map(sdk_model_1.attributeLocalId);
    if (attributes.length === 0) {
        return sdk_model_1.newTwoDimensional([], [sdk_model_1.MeasureGroupIdentifier]);
    }
    return sdk_model_1.newTwoDimensional([sdk_model_1.MeasureGroupIdentifier], attributes);
}
exports.roundChartDimensions = roundChartDimensions;
function heatmapDimensions(def) {
    var view = sdk_model_1.bucketsFind(def.buckets, sdk_ui_1.BucketNames.VIEW);
    var viewAttributeLocalIdentifiers = view ? sdk_model_1.bucketAttributes(view).map(sdk_model_1.attributeLocalId) : [];
    var stack = sdk_model_1.bucketsFind(def.buckets, sdk_ui_1.BucketNames.STACK);
    if (!stack || sdk_model_1.bucketIsEmpty(stack)) {
        return sdk_model_1.newTwoDimensional(viewAttributeLocalIdentifiers, [sdk_model_1.MeasureGroupIdentifier]);
    }
    return sdk_model_1.newTwoDimensional(viewAttributeLocalIdentifiers, sdk_model_1.bucketAttributes(stack).map(sdk_model_1.attributeLocalId).concat([sdk_model_1.MeasureGroupIdentifier]));
}
exports.heatmapDimensions = heatmapDimensions;
function treemapDimensions(def) {
    var attributes = sdk_model_1.bucketsAttributes(def.buckets);
    if (attributes.length === 1) {
        return sdk_model_1.newTwoDimensional([sdk_model_1.MeasureGroupIdentifier], attributes.map(sdk_model_1.attributeLocalId));
    }
    return sdk_model_1.newTwoDimensional(attributes.map(sdk_model_1.attributeLocalId), [sdk_model_1.MeasureGroupIdentifier]);
}
exports.treemapDimensions = treemapDimensions;
//# sourceMappingURL=dimensions.js.map